import { SectionEyebrow } from "@/components/Landing/primitives";

export default function FAQSection({ children }) {
    return (
        <section
            id="resources"
            className="relative py-24 sm:py-32 bg-white text-[#0A0A0A] border-t border-zinc-200"
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="reveal">
                    <SectionEyebrow>FAQ</SectionEyebrow>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1] mt-3">
                        Questions Tier 1 buyers ask.
                    </h2>
                </div>
                <div className="mt-10 reveal">{children}</div>
            </div>
        </section>
    );
}
